export class AllocationRequestBudgetComponent {
	constructor() {
	}
} 
